import $ from 'jquery';

class AdditionalEventsSelector {
  constructor() {
    this.initAnchorListToggle();
    this.initSelectList();
  }

  initAnchorListToggle() {
    const $btn = $('.tn-additional-events__btn-toggle-list-view');

    $btn.on('click', () => {
      $('.tn-additional-events__list-view-toggle-contents').slideToggle();

      const isExpanded = $btn.attr('aria-expanded') === 'true';

      $btn.attr('aria-expanded', isExpanded ? 'false' : 'true');
    });
  }

  initSelectList() {
    const $select = $('#tn-additional-events-select');
    const $btn = $('#tn-additional-events-btn-submit');

    $select.on('change', () => {
      const hasSelection = $select.val() !== '';
      $btn.prop('disabled', hasSelection === false);
    });

    $btn.on('click', () => {
      window.location.href = $select.val();
    });
  }
}

export default AdditionalEventsSelector;



// WEBPACK FOOTER //
// ./src/events/detail/AdditionalEventsSelector.js